<template>
  <div class="cutThePrice">
    <div class="toBeRefer" v-if="details.cutPriceEnable && details.itemCutPriceInfoDTO == null">
      <div class="img_wrpr">
        <img
          src="../../../assets/images/detail/cuttheprice.png"
          class="img_wrppr wdth100"
          alt="cut-the-price"
        />
      </div>
      <div class="share_link">
        <div class="prdt_hdng">{{$t('cutThePrice')}}</div>
        <p class="cashback_txt">{{$t('addFriends')}}</p>
        <div class="customButtom">
          <button
            type="button"
            class="white_btn"
            @click="shareFunc(details.shareMessageUrl,details.itemMediaDTOList[0].original, details.saleReferenceID)"
          >{{$t("shareWithFrnds")}}</button>
        </div>
      </div>
    </div>
    <div class="toBeRefer" v-if="details.cutPriceEnable && details.itemCutPriceInfoDTO != null">
      <div class="reffered_detail">
        <div class="refered_header flx">
          <div class="prdt_hdng">{{$t('cutThePrice')}}</div>
          <router-link
            tag="button"
            type="button"
            class="white_btn"
            to="/cutprice-product-listing"
          >{{$t('seeMoreProduct')}}</router-link>
        </div>
        <p class="cashback_txt">{{$t('nowYourProductPrice',{cost:details.finalPaidAmount})}}</p>

        <span
          class="rest_discount"
        >₹{{$t('thatMuchLeft', {price:details.itemCutPriceInfoDTO.remainingCutAmount})}}</span>
        <div class="progress">
          <div
            class="bar"
            :style="{width:details.itemCutPriceInfoDTO.cutPercentageCompleted + '%'}"
          >
            <p class="percent"></p>
          </div>
        </div>

        <div class="progress strip">
          <div
            class="bar"
            :style="{width:details.itemCutPriceInfoDTO.cutPercentageCompleted + '%'}"
          >
            <p class="percent">₹ {{details.itemCutPriceInfoDTO.totalCutAmount }}</p>
          </div>
        </div>
        <div class="customButtom flx">
          <button
            type="button"
            class="white_btn"
            @click="cutPriceUserList(details.saleReferenceID)"
          >{{$t('whoLoseMoney')}}</button>
          <button
            type="button"
            class="white_btn"
            @click="shareFunc(details.shareMessageUrl,details.itemMediaDTOList[0].original, details.saleReferenceID)"
          >{{$t("shareWithFrnds")}}</button>
        </div>
      </div>
    </div>
    <div class="bottomToUp" v-if="details.displaymessage "></div>
    <div class="bottomToUp_content" :class="{'activeBottomtoUp' : details.displaymessage}">
      <div class="popup_content">
        <span class="img_wrapper">
          <img src="../../../assets/images/detail/cuttheprice.png" alt="cut-the-price" />
        </span>
        <h5 class="prdt_hdng">{{$t('cutThePrice')}}</h5>
      </div>
      <p class="refer_msg" v-if="details.displaymessage">{{details.displaymessage}}</p>
      <button
        type="button"
        class="green_btn"
        v-if="details.cutButtonEnable"
        @click="applyCutPrice()"
      >{{$t('lessAmount')}}</button>

      <span class="closePopUp" @click="details.displaymessage =!details.displaymessage">
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
          <path
            fill="#CDCDCD"
            fill-rule="nonzero"
            d="M19.636 3.364C15.15-1.12 7.85-1.122 3.364 3.364c-4.486 4.487-4.485 11.785 0 16.271 4.486 4.487 11.785 4.487 16.272 0 4.485-4.486 4.485-11.785 0-16.27zm-3.599 12.673a.885.885 0 0 1-1.251 0L11.5 12.75l-3.442 3.442a.885.885 0 1 1-1.251-1.251l3.442-3.442-3.286-3.286a.885.885 0 1 1 1.251-1.251l3.286 3.286 3.13-3.13a.885.885 0 1 1 1.25 1.252L12.753 11.5l3.285 3.286a.885.885 0 0 1 0 1.25z"
            opacity=".675"
          />
        </svg>
      </span>
    </div>
    <div class="bottomToUp" v-if="isActivePopUp"></div>
    <div class="middle_popup" :class="{'popUp' : isActivePopUp}">
      <div class="popup_header">
        <span class="prdt_hdng">{{$t('whoLoseMoney')}}</span>
        <span class="user_count">{{cutpricePersonList.totalRecords}} {{$t('people')}}</span>
      </div>
      <ul>
        <li
          v-for="(personList, index) in cutpricePersonList.productPriceCutHistoryDTOs"
          :key="index"
        >
          <span class="img_wrapper">
            <img :src="personList.profileImage" alt="profile-image" v-if="personList.profileImage" />
            <img src="../../../assets/images/dummy.png" alt="profile-image" v-else />
          </span>
          <p class="userdetail">
            <span class="name">{{personList.name}}</span>
            <span
              class="location"
              v-if="personList.location"
            >{{$t('from',{location:personList.location})}}</span>
          </p>
          <span class="cut_amount">₹ {{personList.cutAmount}}</span>
        </li>
      </ul>
      <span class="closePopUp" @click="isActivePopUp =!isActivePopUp">
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
          <path
            fill="#CDCDCD"
            fill-rule="nonzero"
            d="M19.636 3.364C15.15-1.12 7.85-1.122 3.364 3.364c-4.486 4.487-4.485 11.785 0 16.271 4.486 4.487 11.785 4.487 16.272 0 4.485-4.486 4.485-11.785 0-16.27zm-3.599 12.673a.885.885 0 0 1-1.251 0L11.5 12.75l-3.442 3.442a.885.885 0 1 1-1.251-1.251l3.442-3.442-3.286-3.286a.885.885 0 1 1 1.251-1.251l3.286 3.286 3.13-3.13a.885.885 0 1 1 1.25 1.252L12.753 11.5l3.285 3.286a.885.885 0 0 1 0 1.25z"
            opacity=".675"
          />
        </svg>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CutThePrice",
  props: {
    dataCutThePrice: {
      required: true,
      type: Object
    },
    colorBasedCutPrice: {
      type: Object
    }
  },
  data() {
    return {
      shareLinkData: {},
      details: {},
      loading: false,
      isActiveBottomUp: false,
      isActivePopUp: false,
      cutPriceEnable: false,
      cutpricePersonList: {}
    };
  },
  watch: {
    dataCutThePrice() {
      this.details = this.dataCutThePrice;
    },
    colorBasedCutPrice() {
      this.details = this.colorBasedCutPrice;
    }
  },
  methods: {
    shareFunc(shareMessage, shareImage, saleReferenceID) {
      if (this.$cookie.get("X-Auth-Id") != null) {
        this.loading = true;
        this.$store
          .dispatch({ type: "getShareDetailsByItem", payload: saleReferenceID })
          .then(data => {
            this.shareLinkData = data.data;
            this.loading = false;
            shareMessage = data.data.shareMessage;
            const obj = {
              message: shareMessage,
              imageUrl: shareImage
            };
            try {
              JSBridgePlugin.share(JSON.stringify(obj));
            } catch (err) {
              console.log(err);
              window.open("whatsapp://send?text=" + shareMessage);
            }
          })
          .catch(err => {
            this.loading = false;
            console.log(err);
          });
      } else {
        try {
          _prompt_login.promptLogin = res => {
            if (res == "success") {
              console.log(res);
            } else {
              this.loading = false;
            }
          };
          JSBridgePlugin.promptLogin("_prompt_login.promptLogin");
        } catch (err) {
          this.loading = false;
          console.log(err);
        }
      }
    },
    cutPriceUserList(itemId) {
      this.isActivePopUp = true;
      this.availableCutPriceIndex = 0;
      this.$store
        .dispatch({
          type: "getCutPriceProductHistory",
          payload: itemId,
          itemId: this.availableCutPriceIndex
        })
        .then(data => {
          this.loading = false;
          this.cutpricePersonList = data.data;
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    applyCutPrice() {
      this.$emit("applycutprice", true);
    }
  },
  mounted() {
    this.details = this.dataCutThePrice;
    this.details = this.colorBasedCutPrice;
  }
};
</script>
    